export default "__VITE_ASSET__C58EWF8f__"